<template>
  <div class="card-910 content-of-main-section">
    <m-a :href="imageLink" :target="linkTarget">
      <img :src="image" class="img-slider" :alt="alt">
    </m-a>
  </div>
</template>

<script>
import mA from '../Tags/A'
import mImg from '../Tags/Img'
import {CardProps} from "./CardProps";

export default {
  name: "Card910",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps
  }
}
</script>

<style scoped>
.img-slider {
  object-fit: contain;
  aspect-ratio: 16/9;
  cursor: pointer;
  width: 100%;
}
</style>